module.exports = __webpack_public_path__ + "assets/images/sandra_davie.png?v=4bd39173";